import { stats as unprefixedStats } from '@fiverr-private/obs';
import { getIsClient } from '../../utils/getIsClient';
import { getClientDevice } from '../../utils/getClientDevice';
import { GRAFANA_PREFIX } from './grafana.constants';
import { GrafanaEventName, Platform } from './grafana.types';

type MetricValue = NonNullable<Parameters<typeof unprefixedStats.count>[2]>;

const isClient = getIsClient();

const createGrafanaReporter = () => {
    const platform: Platform = isClient ? getClientDevice() : 'server';
    const stats = unprefixedStats.prefix(GRAFANA_PREFIX);

    const parseMetric = (metric: GrafanaEventName): string => metric.replace('%{platform}', platform);

    const count = (metric: GrafanaEventName, value?: MetricValue) => {
        stats.count(parseMetric(metric), value);
    };

    const time = (metric: GrafanaEventName, value?: MetricValue) => {
        stats.time(parseMetric(metric), value);
    };

    return {
        count,
        time,
    };
};

export const globalGrafanaReporter = createGrafanaReporter();
